<template>
    <div class="browser-container">
        <div class="content">
            <div class="title">文章详情<p @click="navigate(url.hbUrlName)">查看原文</p></div>
            <div @click="close" class="close"></div>
            <div class="iframe">
                <iframe :src="url.hbUrlNameHttps" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import common from "@common/common";
export default {
    props: {
        url: {
            type: Object
        }
    },
    data() {
        return {

        }
    },
    methods: {
        navigate(url) {
            common.jumpOut(url)
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped lang="less">
    .browser-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9;
        background: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .content {
            display: flex;
            flex-direction: column;
            position: relative;
            width: 936px;
            height: 552px;
            background: #F9F9F9;
            padding: 20px 30px 0;
            box-sizing: border-box;

            .title {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                font-size: 24px;
                line-height: 33px;
                color: #323B4B;
                font-weight: bold;
                padding-bottom: 20px;
                border-bottom: 1px solid #DCDCDC;
                box-sizing: border-box;
                margin-bottom: 19px;

                p {
                    min-width: 40px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    background: #41B48C;
                    // box-shadow: 2px 2px 8px 0px rgb(0 0 0 / 10%);
                    border-radius: 4px;
                    font-size: 14px;
                    color: #FFF;
                    font-weight: bold;
                    user-select: none;
                    cursor: pointer;
                    padding: 0 10px;
                    box-sizing: border-box;
                    margin-top: 3px;
                    margin-left: 10px;
                }
            }

            .close {
                position: absolute;
                top: 20px;
                right: 20px;
                width: 20px;
                height: 20px;
                background: url('./assets/delIcon.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }

            .iframe {
                width: 100%;
                flex: 1;

                iframe {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>